import { combineReducers } from '@reduxjs/toolkit'
import authReducer from '@/features/auth/store/authSlice'
import metadataReducer from './metadataSlice'
import lessonRuntimeReducer from '@/features/science-of-reading/lessons/store/lessonRuntimeSlice'
import passageEditorReducer from '@/features/lexicals/passages/store/passageEditorSlice'
import taxonomyCatalogReducer from '@/features/lexicals/taxonomies/store/taxonomyCatalogSlice'
import learnerPassageProgressReducer from '@/features/lexicals/passages/store/learnerPassageProgressSlice'
import lexicalLearningReducer from '@/features/lexicals/passages/store/lexicalLearningSlice'
import googleDriveReducer from '@/features/google-drive/store/googleDriveSlice'
import contentTaxonomiesReducer from '@/features/english-content/taxonomies/store/contentTaxonomySlice'
import contentReadingsReducer from '@/features/english-content/readings/store/contentReadingSlice'
import readingSentenceFlowReducer from '@/features/english-content/readings/store/sentenceFlowSlice'
import readingLexicalBatchReducer from '@/features/english-content/readings/store/readingLexicalBatchSlice'
import readingWorkflowReducer from '@/features/workflows/reading/store/readingWorkflowSlice'

const rootReducer = combineReducers({
  auth: authReducer,
  metadata: metadataReducer,
  lessonRuntime: lessonRuntimeReducer,
  passageEditor: passageEditorReducer,
  taxonomyCatalog: taxonomyCatalogReducer,
  learnerPassageProgress: learnerPassageProgressReducer,
  lexicalLearning: lexicalLearningReducer,
  googleDrive: googleDriveReducer,
  contentTaxonomies: contentTaxonomiesReducer,
  contentReadings: contentReadingsReducer,
  readingSentenceFlow: readingSentenceFlowReducer,
  readingLexicalBatch: readingLexicalBatchReducer,
  readingWorkflow: readingWorkflowReducer,
})

export default rootReducer
